export function GridBg() {
  return <div className="grid-bg" aria-hidden="true" />;
}
